<!--
 * @Description:
 * @Version: 2.0
 * @Autor: dudedu
 * @Date: 2022-08-02 10:16:52
 * @LastEditors: dudedu
 * @LastEditTime: 2023-01-18 15:26:59
-->
<template>
  <el-container class="base-height_width_all_fullscreen">
    <el-aside class="base-flex__column-between">
      <div class="helpCenter-logo-menu helpCenter-border">
        <img height="28px" src="@/assets/image/logo.png" alt="">
      </div>
      <div class="helpCenter-button helpCenter-border">
        <div class="helpCenter-button_div">
          <!--          <el-button @click="check('/introduction')">简介</el-button>-->
          <!--          <el-button @click="check('/notice')">动态核公告</el-button>-->
          <!--          <el-button @click="check('/FAQ')">FAQ</el-button>-->
          <el-button @click="check('/messageInfo')">消息中心</el-button>
        </div>
        <!--        <div class="helpCenter-personal">-->
        <!--          <img class="figure" :src="userInfo.figure_url" alt="">-->
        <!--          <span>{{userInfo.nickname}}</span>-->
        <!--        </div>-->
      </div>
      <!--      <div class="helpCenter-logo-menu">-->
      <!--        <i class="el-icon-s-fold"></i>-->
      <!--      </div>-->
    </el-aside>
    <el-container>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer>Copyright @ 2019-{{ new Date().getFullYear() }} Tencent. All Rights Reserved</el-footer>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'helpCenter',
  data() {
    return {
      userInfo: {},
    };
  },
  methods: {
    /**
     * 获取用户信息
     */
    // async getUserInfo() {
    //   try {
    //     const res = await postRequest('/api/common/getUserInfo', {
    //       ProjectId: 1,
    //     });
    //
    //     this.userInfo = res;
    //   } catch (e) {
    //     this.$message('GET_QQ_PORTRAIT_ERROR', e);
    //   }
    // },
    /**
     * 路径跳转
     */
    check(path) {
      this.$router.push(path);
    },
  },
  mounted() {
    // this.getUserInfo();
  },
};
</script>

<style scoped lang="scss">
  .el-main {
    padding: 24px 24px 0;
    background-color: #eee;
  }
  .el-aside {
    width: 232px!important;
  }
  .el-button {
    border: 0;
    text-align: left;
    margin: 0;
    height: 36px;
    padding: 12px 16px;
  }
  .el-footer {
    height: 56px !important;
    font-size: 12px;
    color: rgba(0,0,0,0.4);
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: center;
    background-color: #eee;
    line-height: 56px;
  }
  .helpCenter-logo-menu {
    height: 56px;
    display: flex;
    align-items: center;
    padding-left: 24px;
    text-align: left;
  }
  .helpCenter-button {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 8px 16px;
    justify-content: space-between;
  }
  .helpCenter-button_div {
    display: flex;
    flex-direction: column;
  }
  .helpCenter-border {
    border-bottom: 1px solid #eee;
  }
  .helpCenter-personal {
    padding-left: 16px;
    text-align: left;
    display: flex;
    align-items: center;
  }
  .figure {
    width: 34px;
    height: 34px;
    display: inline-block;
    border-radius: 50%;
    margin-right: 10px;
  }
</style>
